import { UNAUTHENTICATE_USER } from 'modules/App/store/action-types';

import { LogoutActionCreator } from './types';

export const revokeUserSession: LogoutActionCreator = () => ({
  type: UNAUTHENTICATE_USER,
});
